<header id="org-layout-quoter-header-container">
  <div class="org-layout-quoter-header">
    <img
      routerLink=""
      class="org-layout-quoter-header__logo"
      src="assets/icons/proquifa-logo-nav.svg"
      alt=""
    />
  </div>
</header>
